/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Step_AccountInputs */

const cs_auth_signup_step_account = /** @type {(inputs: Auth_Signup_Step_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Účet`)
};

const en_auth_signup_step_account = /** @type {(inputs: Auth_Signup_Step_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Auth_Signup_Step_AccountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_step_account = /** @type {((inputs?: Auth_Signup_Step_AccountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Step_AccountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_step_account(inputs)
	return cs_auth_signup_step_account(inputs)
});